/* eslint-disable react/no-unknown-property */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable nordic/no-script-tags */
/* eslint-disable max-len */
/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const Style = require('nordic/style');
const Script = require('nordic/script');
const injectI18n = require('nordic/i18n/injectI18n');
const ProgressIndicatorCircular = require('@andes/progress-indicator-circular');
const MenuUtils = require('../../../utils/menu');
const PageContainer = require('../../components/PageContainer');
const APIReference = require('../../components/APIReference');
const APIReferenceHome = require('../../components/APIReferenceHome');
const FeedbackProvider = require('../../../providers/contextProvider');
const { ApiRefContextProvider } = require('../../../providers/apiRefContextProvider');
const { sanitizePath } = require('../../common/URLSanitizer');
const { trackMelidataPageView } = require('../../common/Melidata');

const { useState, useEffect, useRef } = React;

const View = (props) => {
  const {
    i18n,
    platform,
    lang,
    referenceContent,
    appVersion,
    menuData,
    actualUrl,
    loading,
    appCredentials,
    apiRefLiveTestingEnabled,
    postmanCollectionUrl,
  } = props;
  MenuUtils.init(menuData, 'references');
  const menuItems = MenuUtils.getMenuItems(
    platform.siteId.toLowerCase(),
    lang,
    'references',
  );
  const item = MenuUtils.getItemFromURL(
    sanitizePath(actualUrl?.path),
    platform?.siteId?.toLowerCase(),
    lang,
    'references',
  );

  const contentContainer = useRef(null);
  const [activeItem, setActiveItem] = useState(item);
  const [htmlContent, setHtmlContent] = useState(referenceContent);
  const [homePage, setHomePage] = useState(!referenceContent);
  const paths = referenceContent ? referenceContent.paths : {};
  const apiEndpoint = paths ? Object.keys(paths)[0] : null;

  const getMetaDescription = () => {
    if (!referenceContent) {
      return i18n.gettext(
        'Implementa la solución de pagos ideal para cualquier tipo de negocio',
      );
    }
    const apiMethod = Object.keys(paths[apiEndpoint])[0];
    const apiData = paths[apiEndpoint][apiMethod];
    return `${apiData?.title?.[lang]} - ${apiData?.description?.[lang]}`;
  };
  useEffect(() => {
    setHomePage(!referenceContent);
    if (referenceContent) {
      setHtmlContent(referenceContent);
    }
  }, [referenceContent]);

  useEffect(() => {
    if (window && window.Prism && htmlContent) {
      window.Prism.highlightAll();
    }
    contentContainer.current.scrollIntoView();
    window?.scrollTo(0, 0);

    // Para "destravar a tela"
    contentContainer.current.click();
  }, [htmlContent]);

  useEffect(() => {
    if (window && window.Prism) {
      window.Prism.highlightAll();
    }
  }, [homePage]);

  const changedActiveItem = useRef(false);
  useEffect(() => {
    if (activeItem?.lvl !== 0) window.scrollTo(0, 0);
    if (activeItem && activeItem?.url !== '#' && changedActiveItem.current) {
      trackMelidataPageView('/developers/reference', lang, activeItem?.url, 'reference');
    }
    changedActiveItem.current = true;
  }, [activeItem]);

  const isNotHomePage = (htmlContent && !homePage);

  return (
    <FeedbackProvider>
      <PageContainer
        {...props}
        menuItems={menuItems}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        setHtmlContent={setHtmlContent}
        footerClassNames="footer__home"
        type="references"
        metaDescription={paths[apiEndpoint] ? getMetaDescription() : {}}
        state={props}
      >
        <div name="reference" platform={platform}>
          <Script priority={1} src={`https://http2.mlstatic.com/frontend-assets/dx-devsite/javascripts/prism.js?v=${appVersion}`} />
          <Script src="reference.chunk.js" priority={12} />
          <Style href="reference-styles.css" />
          <Style href="app-styles.css" />
          <Script src="reference.js" priority={13} />
          <ApiRefContextProvider
            lang={lang}
            i18n={i18n}
            platform={platform}
            paths={paths}
            appCredentials={appCredentials}
            apiRefLiveTestingEnabled={apiRefLiveTestingEnabled}
            postmanCollectionUrl={postmanCollectionUrl}
          >
            <div>
              {!loading && (
                <div className={`reference-container ${isNotHomePage && 'reference-container-content'}`} ref={contentContainer}>
                  {isNotHomePage && (
                    <APIReference {...props} referenceContent={htmlContent} />
                  )}
                  {homePage && <APIReferenceHome className="reference-container__home" {...props} />}
                </div>
              )}

              {loading && (
                <div className="inner-content--empty">
                  <ProgressIndicatorCircular modifier="block" size="large" />
                </div>
              )}
            </div>
          </ApiRefContextProvider>
        </div>
      </PageContainer>
    </FeedbackProvider>
  );
};

View.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
  }).isRequired,
  actualUrl: PropTypes.shape({
    host: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    fullPath: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
};

/**
 * Inject i18n context as props into View.
 */
module.exports = injectI18n(View);
